import { observer } from 'mobx-react';
import { T } from '../../../../../../Translations';
import Loader from '../../../../../Loader';
import { PublicNameProgramFamilyShareUrl } from '../../../../Types';
import CreateShareUrlStore from '../CreateShareUrlStore';
import InviteParticipantStore from '../InviteParticipantModal/Store';
import TableBody from './TableBody';

interface Props {
  store: CreateShareUrlStore;
  inviteParticipantStore: InviteParticipantStore;
  programFamilyShareUrls: PublicNameProgramFamilyShareUrl[];
}

function LinksTable({ store, programFamilyShareUrls, inviteParticipantStore }: Props) {
  switch (store.state.kind) {
    case 'error':
    case 'waiting':
    case 'ready':
      return (
        <div className="max-w-clientPortalMaxWidth px-2.5 lg:px-12">
          <table className="w-full lg:mb-12 mb-2.5 mx-auto">
            <thead>
              <tr className="text-left bg-gray-50 p-5 border-b-1 border-gray-300 text-sm">
                <th className="p-5">
                  <T kind="Title" />
                </th>
                <th className="p-5">
                  <T kind="Program Type" />
                </th>
                <th className="p-5">
                  <T kind="Partner" />
                </th>
                <th className="p-5">
                  <T kind="Delivery Channel" />
                </th>
                <th className="p-5">
                  <T kind="Access Options" />
                </th>
                <th className="p-5">
                  <T kind="Deep Link Enabled" />
                </th>
              </tr>
            </thead>
            <tbody>
              <TableBody
                programFamilyShareUrls={programFamilyShareUrls}
                inviteParticipantStore={inviteParticipantStore}
              />
            </tbody>
          </table>
        </div>
      );
    case 'creating':
      return <Loader className="h-full" />;
  }
}

export default observer(LinksTable);
